import { render, staticRenderFns } from "./TarefasList.vue?vue&type=template&id=17c45d84"
import script from "./TarefasList.vue?vue&type=script&lang=js"
export * from "./TarefasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports